import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { OneWayInService } from 'src/api/v2';
import { ONE_WAY_IN_ACTORS_WITH_ACCESS } from 'src/constants/hook-keys';
import { useAuth } from 'src/features/authorization';

const useActorsWithAccess = (formId: string) => {
  const [service] = useState(() => new OneWayInService());
  const { checkAccess } = useAuth();
  const { read } = checkAccess('OneWayIn');

  const { data, ...rest } = useQuery({
    queryKey: [ONE_WAY_IN_ACTORS_WITH_ACCESS, formId],
    queryFn: () => service.getActorsWithAccessToOpportunity(formId),
    enabled: read && !!formId,
    retry: false,
    staleTime: 1000 * 60 * 5, // 5 min refetching on mount
    refetchOnMount: true,
  });

  return {
    actors: data,
    ...rest,
  };
};

export default useActorsWithAccess;
